<template>
  <div class="data-list">
    <content-panel>
      <template v-slot:search>
        <search-box class="search-box">
          <el-form
            :inline="true"
            :model="searchForm"
            ref="searchForm"
            label-width="110px"
            size="mini"
          >
            <el-form-item label="模版ID" prop="templateId">
              <el-input
                v-model="searchForm.templateId"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
           <el-form-item label="模版主题" prop="smsTheme">
              <el-input
                v-model="searchForm.smsTheme"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item label="更新人" prop="updatedBy">
              <el-input
                v-model="searchForm.updatedBy"
                clearable
                placeholder="请输入"
              ></el-input>
            </el-form-item>
           
          </el-form>
          <template v-slot:right>
            <el-button size="small" type="primary" @click="onSearch">
              查询
            </el-button>
            <el-button size="small" @click="resetSearchForm">重置</el-button>
          </template>
        </search-box>
      </template>
      <table-panel ref="tablePanel">
        <template v-slot:header-left>
          <el-button type="primary" size="small" @click="handleNewAdd">
            新建
          </el-button>
        </template>
        <el-table
          stripe
          v-loading="loading"
          ref="tableRef"
          border
          highlight-current-row
          :data="tableData"
          :height="maxTableHeight"
        >
          <el-table-column prop="templateId" label="模版ID" width="180" align="center"></el-table-column>
          <el-table-column prop="content" label="模版内容" show-overflow-tooltip align="center" ></el-table-column>
          <el-table-column prop="smsTheme" label="模版主题" show-overflow-tooltip align="center"></el-table-column>
          <el-table-column prop="type" label="类型" align="center" width="120"></el-table-column>
          <el-table-column prop="updatedBy" label="更新人" align="center" width="120"></el-table-column>
          <el-table-column prop="updatedTime" label="更新时间" align="center" width="160"></el-table-column>
          <el-table-column label="操作" class-name="action-column" align="center" width="120">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleEdit(scope.row)">编辑</el-button>
            </template>
          </el-table-column>
        </el-table>
        <template v-slot:footer>
          <div style="text-align: right">
            <el-pagination
              @size-change="onSizeChange"
              @current-change="onNumChange"
              :current-page="pageNum"
              :page-size="pageSize"
              :total="total"
              :page-sizes="[20, 50, 100, 200]"
              layout="total, sizes, prev, pager, next, jumper"
            >
            </el-pagination>
          </div>
        </template>
      </table-panel>
    </content-panel>
    <add-dialog
      :isNewAddPopup.sync="isNewAddPopup"
      :formItems="smsTmptFormItems"
      :editData.sync='editData' 
      v-if="isNewAddPopup"
      @onConfirm="onConfirm"
      InputWidth="100%"
      :title="editData.operationType == 'add' ? '新增':'编辑'"
    />
  </div>
</template>

<script>
import tableMixin from "@/utils/tableMixin";
import { smsTmptFormItems } from '../config'
import AddDialog from '../add-dialog.vue';
export default {
  name: "smsTemplateList",
  mixins: [tableMixin],
  components: {
    AddDialog
  },
  data() {
    return {
      isNewAddPopup: false,
      searchForm: {
        templateId: '',
        smsTheme: "",
        updatedBy: "",
      },
      // 表格相关
      tableData: [],
      pageSize: 100,
      pageNum: 1,
      total: 0,
      filterParam: {
      },
      loading: false,
      isClike: true,
      smsTmptFormItems,
      editData: {
        content: '',
        smsTheme: '',
        templateId: '',
        boolSignChoose: '0'
      }
    };
  },
  methods: {
    init() {
      this.getList();
    },
    getList() {
      this.loading = true;
      const params = {
        pageNum: this.pageNum,
        pageSize: this.pageSize,
        filterData: {
          ...this.filterParam,
        },
      };
      this.$api.configure
        .querySmsTemplateList(params)
          .then(({ data: { list, total } }) => {
            this.tableData = list || [];
            this.total = total;
          })
          .finally(() => {
            this.loading = false;
          });
    },
    onSizeChange(pageSize) {
      this.pageSize = pageSize;
      // 切换每页条数后从第一页查询
      this.pageNum = 1;
      this.getList();
    },
    onNumChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },
    resetSearchForm() {
      this.$refs.searchForm.resetFields();
      this.filterParam = {};
      this.onSearch();
    },
    onSearch() {
      // 每次搜索都初始化搜索条件，重新添加合法的条件
      this.filterParam = {};
      for (const [key, val] of Object.entries(this.searchForm)) {
        if (key === "updatedTime" && val) {
        } else if (typeof val !== "undefined" && val !== null && val !== "") {
          this.filterParam[key] = val;
        }
      }
      this.pageNum = 1;
      this.getList();
    },
    handleNewAdd(row) {
      this.editData = {
        content: '',
        smsTheme: '',
        templateId: '',
        operationType: 'add',
        boolSignChoose: '0'
      }
      this.smsTmptFormItems[0].inputConf.disabled = false
      this.isNewAddPopup = true
    },
    onConfirm() {
      if (this.isClike) {
        this.isClike = false
        this.editData.content = '【全友家居】' + this.editData.content 
        this.$api.configure.saveOrUpdateSmsTemplate(this.editData)
          .then(res => {
            this.$message({
              message: '保存成功',
              type: 'success'
            });
            this.isNewAddPopup = false
            this.init()
            this.editData ={}
          }).finally(_=> {
            setTimeout(() => {
              this.isClike = true
            }, 500);
          })
      }
    },
    handleState(row,useStatus) {
      const {liveRoomId} = row
      this.$api.configure.updateUseStatus({liveRoomId,useStatus})
        .then(res => {
          this.$notify.success({
            title: '成功',
            message: '操作成功',
          });
          this.init()
        })
    },
    handleEdit(row) {
      this.editData = {...row}
      this.editData.content =  this.editData.content.slice(6)
      this.editData.operationType = 'update'
      this.smsTmptFormItems[0].inputConf.disabled = true
      this.isNewAddPopup = true
    }
  },
  filters: {
    ruleType(val) {
      const map = {
        1: '个人',
        2: '部门',
        3: '指定部门'
      };
      return map[val] || '';
    }
  },
  created() {
    this.init();
  },
};
</script>
<style lang="stylus" scoped>
.date-input
  width 220px !important
</style>
